<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Order Number</th>
                    <th class="text-right">Order Amount</th>
                    <th>Party Name</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in purchase" :key="i">
                    <td> {{ item.date }}</td>
                    <td>
                       {{ item.bill_number }}
                    </td>
                    <td class="text-right"> {{ item.bill_amount }}</td>
                    <td> {{ item.party_name }}</td>
                    <td>
                        <button class="btn btn-primary btn-sm mr-5"
                                @click="goToEdit(item.id)"
                                style="cursor: pointer"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                        
                        <button @click="goToInvoice(item)"  class="btn btn-primary btn-sm mr-5">
                            <i class="fas fa-plus"></i>
                            Create Invoice
                        </button>
                        
                        <button @click="printPreInvoice(item)"  class="btn btn-secondary btn-sm">
                         <i class="fa fa-print"></i>
                        </button>
                    </td>
                </tr>

                </tbody>
            </table>
            <p v-if="!purchase.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script>
import figureFormatter from '@/services/utils/figureFormatter';
import handlePurchase from "@/services/modules/purchase";
import piPdfPrint from '@/services/utils/piPdfPrint';
import handleCompany from "@/services/modules/company";
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import { formatDate } from '@/services/utils/global';
import handleHospital from '@/services/modules/hospital'

export default {  
    name: 'PurchaseListTable',
    data() {
        return{
            companyInfo: {},
            invoice: {},
            barcodeQuery: '',
            barcode: '',
            user: {},
            qrcode: '',
            invoiceNotes: [],
            customizationPdfFields:[],
            singleSalesOrder: {}
        }
    },
    props: {
        purchase: Array,
        route_name: {
            type: String,
            default: 'purchase-bill-edit'
        },
        fromApproval: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const {commaFormat} = figureFormatter()
        const { fetchSalesBill, fetchSalesOrderById } = handlePurchase();
        const {fetchCompanyInfo, fetchActiveCustomizationField} = handleCompany();
        const { exportToPDF } = piPdfPrint();
        const { fetchBarcode } = handleBarcode();
        const store = useStore();
        const { notesByType } = handleHospital()

        return {
            commaFormat,
            fetchSalesBill,
            fetchSalesOrderById,
            exportToPDF,
            fetchCompanyInfo,
            fetchBarcode,
            store,
            notesByType,
            fetchActiveCustomizationField
        }
    },
    mounted() {
         this.fetchCompanyInfo(this.$route.params.companyId).then( (res) => {
            this.companyInfo = res.data;
         }).catch((error) => {
            console.log(error);
         });

         this.getInvoiceNotes();
         this.getActiveFiledCustomization()

         this.user = this.store.state.user.user
    },
    methods: {
        async getInvoiceNotes () {
            const companyQuery = `?company_id=${this.$route.params.companyId}&show_default_only=1`;
            await this.notesByType(companyQuery, "invoice_terms").then((res) => {
                if(! res.status) return;
                this.invoiceNotes = res.data.filter((item) => item.full_desc);
            })
        },

        async getActiveFiledCustomization () {
          const companyQuery = `?company_id=${this.$route.params.companyId}&customization_type=pdf&type=pi_pdf_list`;
          await this.fetchActiveCustomizationField(companyQuery).then((res) => {
              this.customizationPdfFields = res.data
          })
        },

        async printPreInvoice(item) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;
            await this.fetchSalesOrderById(item.id, companyQuery).then(async (res) => {
                if(! res.data) return;

                this.singleSalesOrder = res.data

                let qrcodeData = JSON.stringify({
                    ref_no: this.singleSalesOrder.bill_number,
                    ref_date: this.singleSalesOrder.date,
                    created_by: this.singleSalesOrder.created_by_name,
                    created_date_time: formatDate(new Date())
                })

                this.barcodeQuery = `?code=${this.singleSalesOrder.bill_number}&qrcode=${qrcodeData}`;

                await this.fetchBarcode(this.barcodeQuery).then( (res) => {
                    if(res.status){
                        this.qrcode = res.qrcode
                        this.exportToPDF(this.companyInfo, this.singleSalesOrder, this.barcode, this.qrcode, this.user.name, 1, this.invoiceNotes, this.customizationPdfFields)
                    }
                })
            })
            .catch( (err) => {
                console.log("Something went wrong");
            })
        },
        async goToPrint(id) {
            const companyQuery = `?company_id=${this.$route.params.companyId}`;

            await this.fetchSalesBill(id, companyQuery).then( async (res) =>{

                    if(! res.status) return;
                    this.invoice = res.data;

                    let qrcodeData = JSON.stringify({
                        ref_no: this.invoice.bill_number,
                        ref_date: this.invoice.date,
                        created_by: this.invoice.created_by_name,
                        created_date_time: formatDate(new Date())
                    })

                    this.barcodeQuery = `?code=${this.invoice.bill_number}&qrcode=${qrcodeData}`;

                    await this.fetchBarcode(this.barcodeQuery).then( (res) => {
                        if(res.status){
                            this.barcode = res.barcode;
                            this.qrcode = res.qrcode
                            this.exportToPDF(this.companyInfo, this.invoice, this.barcode, this.qrcode, this.user.name, 1, this.invoiceNotes)
                        }
                    })

                }).catch( (err) => {
                    console.log(err);
                    console.log("Something went wrong");
                })
        },
        goToInvoice(item) {
            this.$router.push({
                name: 'sales-invoice-add',
                params: this.$route.params,
                query: {
                    start: this.$route.query.start,
                    end: this.$route.query.end,
                    sales_order_id: item.id,
                    redirect_route: 'sales-order-approval'
                }
            })
        },
        goToEdit(id) {
            let dynamicKeyName = (this.route_name === 'purchase-bill-edit') ? 'purchaseId' : 'salesId'
            let param = {
              companyId: this.$route.params.companyId,
              moduleId: this.$route.params.moduleId,
              menuId: this.$route.params.menuId,
              pageId: this.$route.params.pageId,
            }
            param[dynamicKeyName] = id;

            const query = this.$route.query;
            if(this.$route.name === 'sales-order-approval'){
                query.type = 'approval';
            }

            this.$router.push({
                name: this.route_name,
                params: param,
                query: query
            })
        }
    }
}
</script>

<style scoped>
.btn-challan {
    background-color: #249024 !important;
}
</style> 